


































import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import PlanosAba from "../tables/PlanosAba.vue";
import Confirm from "@/shared/components/confirm.vue";
import { ConsultoresService } from "@/services/consultores.service";

@Component({
  components: {
    DataTable,
    Confirm,
    PlanosAba,
  },
})
export default class LimpezaEstoque extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  msgEstoque: string | null = "";
  showEstoque?: boolean = false;

  async ZerarEstoque() {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Zerar Estoque`;
    const text = `ESTA AÇÃO NÃO TEM RETORNO!!! Tem certeza que deseja ZERAR ESTOQUE do cliente selecionado?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      const msg = await ConsultoresService.ZerarEstoque(
        this.idConsultor
      ).finally(this.stopLoader);
      if (msg) {
        this.msgEstoque = "Estoque zerado com sucesso!";
        this.showEstoque = true;
        setTimeout(this.fechaAlertaEstoque, 5000);
      }
    }
  }
  fechaAlertaEstoque() {
    this.showEstoque = false;
  }
}
